import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import HeroSection from "../../components/hero/Hero";
import AboutSection from "../../components/about/about";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import IndustriesMarqueeSection from "../../components/IndustriesMarqueeSection/IndustriesMarqueeSection";
import IndustriesSection from "../../components/Industries/Industries";
import ContactSection from "../../components/ContactSection/ContactSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { useLanguage } from "../../context/LanguageContext";

const HomePage: React.FC = () => {
  const { t } = useLanguage();

  useEffect(() => {
    document.title = `${t.company.name} | ${t.company.tagline}`;
  }, [t.company.name, t.company.tagline]);

  return (
    <Fragment>
      <div className="ai-agency">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <HeroSection />
            <AboutSection />
            <ServiceSection />
            <ProjectSection />
            {/* <IndustriesMarqueeSection /> */}
            {/* <IndustriesSection /> */}
            {/* <ContactSection /> */}
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default HomePage;
